<template>
    <div class="main-bg">
        <Nav></Nav>
        <div class="content">
            <div class="box">
                <template v-if="loading">
                    <skeletonDetail></skeletonDetail>
                </template>
                <template v-else-if="coursePkg">
                    <div class="nav">
                        <a @click="$router.push({ name: 'index' })">首页</a> /
                        <a @click="$router.push({ name: 'index' })">学习中心</a> /
                        <span>{{ coursePkg.name }}</span>
                    </div>
                    <div class="book-info">
                        <div class="book-info-box">
                            <div class="book-thumb">
                                <thumbbar :value="coursePkg.thumb"
                                           :width="305"
                                           :height="172"></thumbbar>
                            </div>
                            <div class="info">
                                <div class="book-info-title">{{ coursePkg.title }}</div>
                                <p class="desc" v-html="coursePkg.desc"></p>

                            </div>
                        </div>

                    </div>
                    <div class="book-chapter-box">                     
                        <div class="steps-box">
                            <div class="courses-box">
                            <el-timeline>
                                <el-timeline-item v-for="(activity, index) in coursePkg.courses"
                                                  :key="index"
                                                  :icon="activity.icon"
                                                  :type="activity.e_type"
                                                  :color="activity.color"
                                                  size="large"
                                                  :timestamp="activity.timestamp">
                                    <div class="course-item" @click="goDetail(activity)">
                                        <div class="course-thumb">
                                            <div class="thumb-bar">
                                                <thumbbar :value="activity.thumb"
                                                          :width="170"
                                                          :height="100"
                                                          :border="4"></thumbbar>
                                            </div>

                                        </div>
                                        <div class="course-body">
                                            <div class="course-name">{{ activity.name }}</div>
                                            <div class="course-type">
                                                在线课程
                                            </div>
                                            <div class="course-process">

                                                <el-progress :percentage="activity.progress" :text-inside="true" :stroke-width="20" :color="activity.progress==100?'#409eff':''" :status="activity.progress==100?'success':'warning'" ></el-progress>
                                            </div>

                                        </div>
                                    </div>
                                </el-timeline-item>
                            </el-timeline>
                            </div>
                         
                        </div>

                        </div>
                </template>
            </div>
           
        </div>
    </div>
</template>
<script>

    import SkeletonDetail from "./components/skeletonDetail.vue";
    import Nav from "@/components/nav.vue";
    import thumbbar from "@/components/training/thumb-bar.vue";
    export default {
        components: {
            Nav,
            SkeletonDetail,
            thumbbar,
        },
        data() {
            return {
                loading: false,
                id: this.$route.query.id,
                coursePkg: {
                    "title": "从Java到Python两大王牌语言一次搞定",
                    "id": 2,
                    "thumb": "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLD7NK5Z0ohlBibsRakBB08MDDAnGib7AH2ibSk2icIWKefeVicQwnicuuufCeLSrwurAOJyE/356",
                    "desc": "在Web的迅速发展中，Java被广泛接受并起到了绝对的推动作用。近几年，Python语言也受到了大多数程序员的青睐，本套课程一次搞定两大核心开发语言。",
                    "courses_count": 4,
                    "courses": [
                        {
                            "id": 39,
                            "icon":"el-icon-success",
                            "e_type": "success",
                            "cid": 4,
                            "step_id": 4,
                            "name": "一次性搞定Java入门（高新全栈+安卓）",
                            "thumb": "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLDyo4SsXiaV4Ws4L8mVmGsIpjFotUsk0G8OvL0TzqkphkcNRhaiabSicEKjJB13b3Ow7Q/356",
                            "type": "course",
                            "progress":100,
                            
                        },
                        {
                            "id": 40,
                            "cid": 32,
                            "step_id": 4,
                            "icon": "el-icon-success",
                            "e_type": "success",
                            "name": "SpringCloud实战（k8s&doceker）",
                            "thumb": "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLD5WGjsXDzicVmeOmwMWTHFo4EVxaV9icz1hQMibsZDt56icx4utAaoee6D7ICgjGKHFgY/356",
                            "type": "course",
                            "progress": 100,
                           
                        },
                         {
                            "id": 34,
                            "cid": 42,
                             "step_id": 5,
                             "color": '#0bbd87',
                            "name": "零基础写下第一行Python代码",
                             "thumb": "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLBHst1ua1XZ57xn2CUGbC53aVNk3bOBYxvXkrUttLhmibIpPdsugwown1iaFmmOM3ia0g/356",
                             "type": "course",
                             "progress": 50,
                           
                        },
                        {
                            "id": 35,
                            "cid": 38,
                            "step_id": 5,
                            "name": "Python数据分析（机器学习实战）",
                            "thumb": "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLBZgq7t6uHTBWTf20DOA7cN3pYo4qO2nMODLmFXpBcDRWw9zEaDY88103fMhI6t7YA/356",
                            "charge": 199,
                            "type": "course",
                            "progress": 0,
                           
                        }
                    ]
                },

            };
        },
        computed: {

        },
        mounted() {
            this.getDetail();
        },
        beforeDestroy() { },
        methods: {

            goDetail(item) {
                let page = "";
                if (item.type === "course") {
                    page = "courseDetail";
                } else if (item.type === "exam") {
                    page = "exam";
                }
                this.$router.push({
                    name: page,
                    query: {
                        id: item.cid,
                    },
                });
                },
       
            getDetail() {
                    if (this.loading) {
                        return;
                    }
                    //this.loading = true;
                    //Api.Detail(this.id).then((res) => {
                    //    this.loading = false;
                    //    this.coursePkg = res.data.data;
                    //    document.title = res.data.data.name;
                    //});
                },
            },
        };
</script>
<style lang="scss" scoped>
    .main-bg {
        ::v-deep .el-progress-bar__innerText {
            color: #FFF !important;
        }

        background-image: url("../../../assets/home/backougnd.png");
        background-size: cover;
        overflow-x: hidden;

        .content {
            width: 100%;
            padding-top: 86px;

            .fix-nav {
                width: 100%;
                background-color: #fff;
                position: sticky;
                top: 0;
                z-index: 50;

               
            }

            .box {
                width: 1200px;
                margin: 0 auto;

                .nav {
                    width: 100%;
                    height: auto;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    align-items: center;
                    font-size: 14px;
                    color: #999999;
                    line-height: 14px;
                    margin-top: 30px;
                    margin-bottom: 30px;

                    a {
                        height: auto;
                        font-size: 14px;
                        font-weight: 400;
                        color: #999999;
                        line-height: 14px;
                        margin-right: 6px;
                        cursor: pointer;

                        &:not(:first-of-type) {
                            margin-left: 6px;
                        }
                    }

                    span {
                        flex: 1;
                        height: auto;
                        margin-left: 6px;
                        font-size: 14px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 14px;
                        display: block;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }

                .book-info {
                    display: flex;
                    width: 1200px;
                    height: auto;
                    background: #ffffff;
                    border-radius: 8px;
                    flex-direction: column;

                    .book-info-box {
                        width: 100%;
                        height: 300px;
                        box-sizing: border-box;
                        padding: 30px 50px 30px 30px;
                        position: relative;
                        display: flex;
                        flex-direction: row;

                        .book-thumb {
                            width: 320px;
                            height: 240px;
                            border-radius: 8px;
                            margin-right: 50px;
                            position: relative;
                            overflow: hidden;

                            .status {
                                position: absolute;
                                top: 10px;
                                left: 10px;
                                background-color: rgba(60, 167, 250);
                                color: #fff;
                                font-size: 14px;
                                padding: 4px;
                                border-radius: 4px;
                            }
                        }

                        .info {
                            width: 750px;
                            height: 240px;
                            position: relative;

                            .book-info-title {
                                width: 710px;
                                height: 30px;
                                font-size: 24px;
                                font-weight: 500;
                                color: #333333;
                                line-height: 24px;
                                margin-top: 20px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }

                        
                            .desc {
                                margin-top: 14px;
                                width: 750px;
                                height: 90px;
                                font-size: 16px;
                                font-weight: 400;
                                color: #666666;
                                line-height: 30px;
                                overflow: hidden;
                            }

                         
                        }
                    }

                    
                }

                .book-desc {
                    padding: 30px;
                    background: #ffffff;
                    margin-top: 30px;
                    border-radius: 8px;
                    font-size: 16px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 30px;
                }

                .book-chapter-box {
                    width: 1200px;
                    padding: 50px 30px;
                    background: #ffffff;
                    margin-top: 30px;
                    border-radius: 8px;

                    .steps-box {
                        width: 100%;
                        height: auto;


                        .step-title {
                            width: 100%;
                            height: 20px;
                            font-size: 20px;
                            font-weight: 600;
                            color: #9355de;
                            line-height: 20px;
                            margin-bottom: 10px;
                        }

                        .step-desc {
                            width: 100%;
                            height: auto;
                            max-height: 56px;
                            font-size: 16px;
                            font-weight: 400;
                            color: #333333;
                            line-height: 28px;
                            overflow: hidden;
                            margin-bottom: 30px;
                        }

                        .courses-box {
                            width: 100%;
                            height: auto;

                            .course-item {
                                width: 100%;
                                height: 100px;
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                position: relative;
                                cursor: pointer;

                                &:not(:last-child) {
                                    margin-bottom: 30px;
                                }

                                .course-thumb {
                                    width: 170px;
                                    height: 100px;
                                    background: #f0f0f8;
                                    border-radius: 4px;
                                    margin-right: 30px;
                                    display: flex;
                                    justify-content: center;
                                    overflow: hidden;

                                    .thumb-bar {
                                        width: 100%;
                                        height: 100%;
                                        z-index: 10;
                                        border-radius: 4px;
                                        overflow: hidden;
                                    }

                                    .active {
                                        width: 75px;
                                    }
                                }

                                .course-body {
                                    width: 927px;
                                    height: 100px;
                                    display: flex;
                                    flex-direction: column;

                                    .course-type {
                                        width: 56px;
                                        height: 22px;
                                        background: #04c877;
                                        border-radius: 2px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        font-size: 12px;
                                        font-weight: 400;
                                        color: #ffffff;
                                        margin-bottom: 18px;
                                    }

                                    .course-name {
                                        width: 100%;
                                        height: 14px;
                                        font-size: 14px;
                                        font-weight: 600;
                                        color: #333333;
                                        line-height: 14px;
                                        margin-top: 10px;
                                        margin-bottom: 15px;
                                        overflow: hidden;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                    }

                                    .course-charge {
                                        height: 14px;
                                        font-size: 14px;
                                        font-weight: 500;
                                        color: #999999;
                                        line-height: 14px;
                                    }

                                    .course-process {
                                        height: 14px;
                                        font-size: 14px;
                                        font-weight: 500;
                                        color: #04c877;
                                        line-height: 14px;
                                        width: 30%
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
